export type PlanProductType = 'dental' | 'vision'

interface DisablePlanActionInput {
  readOnly: boolean
  product: PlanProductType
  hasDentalPlans: boolean
  hasVisionPlans: boolean
}

export function isReadOnlyFromUrl(search: string = window.location.search) {
  return new URLSearchParams(search).get('readOnly') === 'true'
}

export function shouldDisablePlanAction({
  readOnly,
  product,
  hasDentalPlans,
  hasVisionPlans,
}: DisablePlanActionInput) {
  if (!readOnly) {
    return false
  }

  if (product === 'dental') {
    // Disable only in dental-only read-only flow.
    return hasDentalPlans && !hasVisionPlans
  }

  // Disable in read-only mode when vision plans are present (vision-only and both).
  return hasVisionPlans
}
